import React from 'react';
import Checkbox from '../checkbox';
import StoreLocatorFilter from './store-locator-filter';

export class StoreLocatorSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postcode: this.props.postcode,
      searchAsMapMoves: true,
      searching: false,
      searchFilter: this.props.searchFilter,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSetLocation = this.handleSetLocation.bind(this);
    this.handleCurrentLocation = this.handleCurrentLocation.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.postcode !== this.props.postcode) {
      if (this.state.searching) {
        this.setState({searching: false});
      } else {
        this.setState({postcode: this.props.postcode});
      }
    }
  }

  handleSetLocation(e) {
    e.preventDefault();
    if (!this.state.postcode) {
      return;
    }
    this.setState({searching: true});
    this.props.onSetLocation(this.state.postcode);

    if (this.props.isMobile) {
      this.textinput.blur();  //hide mobile keyboard on Return key press
    }
  }

  handleChange(event) {
    this.setState({postcode: event.target.value});
  }

  handleCurrentLocation(e) {
    e.preventDefault();
    this.setState({postcode: ''});
    this.props.onSetCurrentLocation();
  }

  onChangeCheckbox() {
    const newValue = !this.state.searchAsMapMoves;
    this.setState({searchAsMapMoves: newValue});
    this.props.searchAsMapMoves(newValue);
  }

  toggleFilter = (filter) => {
    this.setState((prevState) => {
      const { searchFilter } = prevState;
  
      if (searchFilter.length === 1 && searchFilter.includes(filter)) {
        return null;
      }
  
      const newSearchFilter = searchFilter.includes(filter)
        ? searchFilter.filter((f) => f !== filter)
        : [...searchFilter, filter];
  
      this.props.onFilterChange(newSearchFilter);
  
      return { searchFilter: newSearchFilter };
    });
  };

  render() {
    return (
      <div className='store-locator-find-form-container-yodel'>
        <div className="yodel-store-locator-search-headline">
          <h3>{this.props.isInPostStoreLocatorRebrandEnabled ? "InPost Shops near you" : this.props.isInPostEnabled ? "InPost Lockers and Yodel Stores near you" : "Yodel Stores near you"}</h3>
        </div>

        <div className="yodel-store-locator-search-as-map-moves-container">
          {!this.props.isMobile &&
            <Checkbox
              id="search-as-map-moves-checkbox"
              checked={this.state.searchAsMapMoves}
              onChange={this.onChangeCheckbox}
            >
              <span className="text-ellipsis" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block', maxWidth: '100%' }}>
              Search as I move the map
              </span>
            </Checkbox>
          }
        </div>
        <form 
          className="yodel-store-locator-input-container"
          style={{marginBottom: 8}}
          onSubmit={this.handleSetLocation}>
          <div className="branded-form-element-container input-ellipsis -yodel">
            <label className="label-branded" htmlFor="from_postcode">
              {this.props.isMobile ?
              (
                <input ref={ (textinput) => this.textinput = textinput }
                type="text" name="from_postcode"
                id="from_postcode"
                className="input-branded -gray"
                value={this.state.postcode}
                placeholder="Enter your postcode or location"
                onChange={this.handleChange} />
              ) :
              (
                <>
                <input ref={ (textinput) => this.textinput = textinput }
                  type="text"
                  name="from_postcode"
                  id="from_postcode"
                  className="input-branded -gray"
                  value={this.state.postcode}
                  onChange={this.handleChange} />
                <span className="label-branded-text">
                  Enter your postcode or location
                </span>
                </>
              )
              }
            </label>
          </div>
          {this.props.isMobile ?
            <input type="submit" value="" name="commit" id="search_from" className="yodel-outline-button search-button" /> :
            <input type="submit" name="commit" value="Search" id="search_from" className="yodel-outline-button" />
          }
          {this.props.isMobile &&
            <div className="my-location-image-wrapper">
              <img
              src="/assets/store-locator/my-location-icon.svg"
              onClick={this.handleCurrentLocation}
              className="my-location-image"
              />
            </div>
          }
          {!this.props.isMobile &&
            <div className="my-location-image-wrapper">
              <img
              src="/assets/store-locator/my-location-icon.svg"
              style={{marginLeft: 20, marginRight: 12}}
              onClick={this.handleCurrentLocation}
              className="my-location-image"
              />
            </div>
          }
        </form>
        {this.props.isInPostEnabled &&
          <StoreLocatorFilter
            isStoreChecked={this.state.searchFilter.includes("paypoint")}
            isLockerChecked={this.state.searchFilter.includes("in_post_locker")}
            toggleFilter={this.toggleFilter} />
        }
      </div>
    );
  }
}
